import { core } from '@/core'
import Basic from '@basic'
import { Checkbox } from '@bag'

const util = {
  pullData(opt, tar, value) {
    const { id = 'id', text = 'text' } = opt
    if ($.type(value) === 'array') {
      const div = $('<div></div>')
      tar.checkboxItem = value.map((item) => {
        const value = item[id]
        const label = item[text]
        const checkbox = new Checkbox(Object.assign({}, opt, { value, label }))
        checkbox.change($.proxy(tar.change, tar))
        checkbox.click($.proxy(tar.click, tar))
        div.append(checkbox.unit)
        return checkbox
      })
      tar.unit.html(div.children())
    }
  },
  template: {
    checkboxGroup() {
      return $(
        '<div class="checkbox-group" role="group" aria-label="checkbox-group"></div>'
      )
    },
  },
  updater: {
    // 原生属性
    name(value, opt, tar, node) {},
    disabled(value, opt, tar, node) {
      const { checkboxItem = [] } = tar
      if (value || value === '') {
        tar.unit.addClass('is-disabled')
        checkboxItem.map((obj) => {
          obj.disabled = true
        })
      } else {
        tar.unit.removeClass('is-disabled')
        checkboxItem.map((obj) => {
          obj.disabled = false
        })
      }
    },
    // 基本功能
    valueArray(value, opt, tar, node) {
      const { checkboxItem = [] } = tar
      if ($.type(value) === 'string' && value) {
        tar.valueArray = value.split(',')
      } else if ($.type(value) === 'array') {
        checkboxItem.map((obj) => {
          obj.checked = value.includes(obj.value)
        })
      } else {
        tar.valueArray = []
      }
    },
    size(value, opt, tar, node) {
      value &&
        tar.unit.removeClass('input-size--*').addClass(`input-size--${value}`)
    },
    color(value, opt, tar, node) {
      // TODO: 未完成
    },
    fill(value, opt, tar, node) {
      // TODO: 未完成
    },
    // 扩展功能
    min(value, opt, tar, node) {
      // TODO: 未完成
    },
    max(value, opt, tar, node) {
      // TODO: 未完成
    },
  },
}

export default class CheckboxGroup extends Basic {
  constructor(opt) {
    super(opt)
    const def = {
      type: 'checkbox', // 控件类型
    }
    this.defaults = {
      name: '', // 原生属性: name
      disabled: false, // 原生属性: 禁用(true/false)

      valueArray: [], // 基本功能: 值(数组格式)
      size: '', // 基本功能: 尺寸
      color: '', // 基本功能: 按钮形式的 Checkbox 激活时的文本颜色
      fill: '', // 基本功能: 按钮形式的 Checkbox 激活时的填充色和边框色

      min: '', // 扩展功能: 可被勾选的最小数量
      max: '', // 扩展功能: 可被勾选的最大数量
    }
    this.events = {
      reset: null, // 重置data
      change: 'onChange', // 选项变化事件
      click: null, // 选项被点击事件
    }
    this.selfData = [
      { id: '1', text: '是' },
      { id: '0', text: '否' },
    ]
    core.proxyApi(this) // 核心属性处理
    core.proxyEvent(this) // 核心事件处理
    this.settings = Object.assign({}, def, this.defaults, opt)
    this.init()
  }

  init() {
    const opt = this.settings
    const template = util.template.checkboxGroup(opt, this)
    this.members = {}
    this.unit = template
    this.data = this.settings.data
    core.update(util.updater, opt, this)
  }

  destroyed() {
    this.unit.empty().remove()
  }

  handleClick(target) {
    if (target) {
      const arr = this.valueArray
      const value = target.value
      const index = arr.findIndex((x) => x === value)
      if (index < 0) {
        arr.push(value)
      } else {
        arr.splice(index, 1)
      }
      this.valueArray = arr
    }
  }

  onChange(target) {
    this.handleClick(target)
  }

  onClick(target) {
    this.handleClick(target)
  }

  set data(value = this.selfData) {
    this.settings.data = value || [
      { id: '1', text: '是' },
      { id: '0', text: '否' },
    ]
    util.pullData(this.settings, this, value)
  }

  get data() {
    return this.settings.data
  }

  set value(value) {
    this.valueArray = value
  }

  get value() {
    return this.valueArray.join(',')
  }

  get textContent() {
    return this.data
      .filter((x) => this.valueArray.includes(x.id))
      .map((x) => x.text)
      .join(',')
  }
}
